import { useState } from 'react';
import { useT } from '../../i18n';
import MochiConversations from './MochiConversations';
import MochiStories from './MochiStories';

type EnglishLearningTab = 'conversations' | 'stories';

export default function MochiEnglishLearning() {
  const t = useT();
  const [activeTab, setActiveTab] = useState<EnglishLearningTab>('conversations');

  return (
    <section className="space-y-8">
      <header className="max-w-3xl">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-coffee/70">
          {t('mochi.english.kicker')}
        </p>
        <h2 className="mt-3 text-3xl font-semibold text-cocoa md:text-5xl">
          {t('mochi.english.title')}
        </h2>
        <p className="mt-3 leading-relaxed text-coffee">{t('mochi.english.subtitle')}</p>
      </header>

      <div
        role="tablist"
        aria-label={t('mochi.english.tabs.label')}
        className="inline-flex w-fit rounded-xl border border-neutral-200 bg-white/70 p-1 shadow-soft"
      >
        {(['conversations', 'stories'] as const).map((tab) => (
          <button
            key={tab}
            type="button"
            role="tab"
            id={`mochi-english-tab-${tab}`}
            aria-controls={`mochi-english-panel-${tab}`}
            aria-selected={activeTab === tab}
            onClick={() => setActiveTab(tab)}
            className={`rounded-lg px-4 py-2.5 text-sm font-medium transition ${activeTab === tab ? 'bg-tan text-white shadow-sm' : 'text-coffee hover:bg-white hover:text-cocoa'}`}
          >
            {t(`mochi.english.tabs.${tab}`)}
          </button>
        ))}
      </div>

      <div
        id="mochi-english-panel-conversations"
        role="tabpanel"
        aria-labelledby="mochi-english-tab-conversations"
        hidden={activeTab !== 'conversations'}
      >
        {activeTab === 'conversations' && <MochiConversations />}
      </div>
      <div
        id="mochi-english-panel-stories"
        role="tabpanel"
        aria-labelledby="mochi-english-tab-stories"
        hidden={activeTab !== 'stories'}
      >
        {activeTab === 'stories' && <MochiStories />}
      </div>
    </section>
  );
}
